import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import Dialog from '@mui/material/Dialog';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Button from "@mui/material/Button";
import {editSaveDocument, getAlLThis, getDocument, messageReset} from "../store/documents";
import {Slide, toast} from "react-toastify";
import audio_finish from '../finish.mp3'
import {getAllVerifyResponse} from "../store/logIn";
import axios from 'axios';

function ScanDocument(props) {
    let finish = new Audio(audio_finish)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        // Reset local state first
        setOpen(false);
        setLoading(false);

        // Then reset parent state
        setTimeout(() => {
            props.setOpen(false);
            props.setOpenItem(false);
        }, 100); // Small delay to ensure local state is updated first
    };

    // Updated function to handle both avia and fura tracking
    async function toDelete() {
        setLoading(true);

        try {
            const trackType = props.openItem['type'];

            if (trackType === 'avia' || trackType === 'fura') {
                // Use the combined tracking API for scanning
                const scanData = {
                    serial_number: props.openItem['part'],
                    code: props.openItem['code'],
                    track_code: props.openItem['track_code'],
                    type: trackType,
                    place: 'uzb' // Change place to 'uz' when scanned
                };

                // Make API call to update the tracking record
                const response = await axios.patch(`https://fx.softmakon.uz/api/combined-tracking/scan/`, scanData);

                if (response.status === 200) {
                    finish.play();
                    toast.success("Muvaffaqiyatli saqlandi!", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        transition: Slide,
                    });

                    props.setOpen(false);
                    props.setOpenItem(false);
                }
            }
        } catch (error) {
            console.error('Error scanning document:', error);
            toast.error("Xatolik yuz berdi!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
                transition: Slide,
            });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (props.open) {
            setOpen(props.open)
        }
    }, [props])

    useEffect(() => {
        if (props.message == true) {
            finish.play()
            toast.success("Muvaffaqiyatli saqlandi!",
                {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                    transition: Slide,
                })

            props.messageReset()
            props.setOpen(false)
            props.setOpenItem(false)
        }
    }, [props.message]);

    return <div>
        <Dialog
            open={open}
            className={"scanNow"}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <div className={'delete-modal'}>
                <div className="icon">
                    <HighlightOffIcon color={'error'}/>
                </div>
                <h2>{"Tasdiqlash"}</h2>
                <p>{"Ha tugmasini bosish orqali ushbu buyurtmani joylashgan joyi avtomatik tarzda o'zgaradi va qayta o'zgartira olmaysiz"}</p>
                {props.openItem?.type && (
                    <p>
                        <strong>Turi: </strong>
                        <span className={`badge ${props.openItem.type === 'avia' ? 'bg-primary' : 'bg-success'}`}>
                            {props.openItem.type === 'avia' ? 'Avia' : 'Fura'}
                        </span>
                    </p>
                )}
                <div className="buttons">
                    <Button variant="contained" className={'cancel-btn'} onClick={handleClose} disabled={loading}>
                        {"Yo'q ortga qaytish"}
                    </Button>
                    <Button variant="contained" className={'delete-btn'} onClick={toDelete} disabled={loading}>
                        {loading ? "O'zgartirilmoqda..." : "Ha o'zgartirish"}
                    </Button>
                </div>
            </div>
        </Dialog>
    </div>
}

export default connect(props => props.documents, {
    getDocument,
    editSaveDocument,
    getAllVerifyResponse,
    getAlLThis,
    messageReset
})(ScanDocument)